import { RouterProvider } from "react-router-dom";
import { QueryProvider, ThemeProvider, router } from "./app/index";
import { Toaster as SonnerToaster } from "@/shared/ui/sonner";
import { SentryErrorBoundary } from "@/core/sentry";

function Root() {
  return (
    <SentryErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <SonnerToaster />
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryProvider>
    </SentryErrorBoundary>
  );
}

export default Root;
